import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(logoStyles, {
    container: {
        css: css`
            display: flex;
            justify-content: Center;
        `,
    },
    image: {
        css: css`
            max-width: 300px;
            width: 100%;
            padding: 15px;
            padding-bottom: 30px;
        `,
    },
});
